import React from 'react'

const icon = ({ className }) => (
<svg className={className} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21 16.8775L19.5705 18.2451L12 10.3309L4.42952 18.2451L3 16.8775L12 7.47927L21 16.8775Z" fill="black"/>
</svg>
)

export default icon;